// Ref: https://stackoverflow.com/questions/3224834/get-difference-between-2-dates-in-javascript
const diffInDays = (a, b) => {
  const msPerDay = 1000 * 60 * 60 * 24
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())
  return Math.ceil((utc2 - utc1) / msPerDay)
}

export default diffInDays
